import { createSlice } from '@reduxjs/toolkit';

export interface ConnectionStates {
  lastAliveEventTime?: number;
}

const initialState: ConnectionStates = {};

const serverSentEventsSlice = createSlice({
  name: 'serverSentEvents',
  initialState,
  reducers: {
    aliveEventReceived(state) {
      state.lastAliveEventTime = Date.now();
    },
  },
});

export const { aliveEventReceived } = serverSentEventsSlice.actions;
export default serverSentEventsSlice.reducer;
